const VueApps = () => {
  $(() => {
    const sections = document.querySelectorAll('section.timetable');
    if (sections.length) {
      import('./vue/TimetableApp').then(module => {
        module.default.init();
      });
    }
  });
}

export default VueApps;
